<template>
    <Breadcrumb :items="breadcrumbs" />
    <div class="absence-page container-fluid my-3">

        <!-- ── QR Panel ── -->
        <div class="card mb-3 border-primary">
            <div class="card-body py-3">
                <h6 class="card-title mb-3">
                    <i class="pi pi-qrcode me-1"></i> تسجيل الدفع بـ QR
                </h6>
                <div class="row align-items-end g-2 mb-3 p-3">
                    <div class="col-auto">
                        <label class="form-label mb-1 fw-semibold">البند المالي الحالي</label>
                        <Dropdown
                            v-model="selectedQrItem"
                            :options="financialItems"
                            optionLabel="name"
                            placeholder="اختر البند المالي..."
                            class="w-100"
                            style="min-width:220px"
                        />
                    </div>
                    <div v-if="selectedQrItem" class="col-auto">
                        <span class="badge bg-success fs-6 px-3 py-2">
                            <i class="pi pi-check-circle me-1"></i>
                            {{ selectedQrItem.name }}
                        </span>
                    </div>
                    <div v-else class="col-auto">
                        <span class="badge bg-secondary fs-6 px-3 py-2">لم يتم اختيار بند</span>
                    </div>
                </div>
                <BarcodeScanner
                    v-if="selectedQrItem"
                    mode="payment"
                    :processing="isProcessingScan"
                    @scanned="handlePaymentQR"
                    @scan-error="handlePaymentScanError"
                />
                <p v-else class="text-muted small mb-0">اختر البند المالي أولاً لتفعيل الماسح.</p>
                <div v-if="scanLookupLoading" class="mt-2 text-primary small">
                    <span class="spinner-border spinner-border-sm me-1"></span>
                    جاري تسجيل الدفع...
                </div>
            </div>
        </div>

        <!-- ── Filters ── -->
        <div class="filter my-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <h4>
                    المدفوعات — {{ gradeName }}
                    <span v-if="paggination">({{ paggination }})</span>
                </h4>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-12 col-12">
                    <div class="form-group">
                        <label for="pay-search">البحث عن الطالب</label>
                        <input type="search" id="pay-search" class="form-control" placeholder="ابحث باسم الطالب"
                            v-model="word" @keyup="fetchStudents(1)">
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label>الجنس</label>
                        <Dropdown v-model="gender" :options="gender_list" optionLabel="title"
                            placeholder="الجنس" @change="fetchStudents(1)" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label>نظام الدراسة</label>
                        <Dropdown v-model="studyModeFilter" :options="studyModeFilterOptions" optionLabel="title"
                            placeholder="نظام الدراسة" @change="fetchStudents(1)" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label>البند المالي</label>
                        <Dropdown v-model="filterFinancialItem" :options="financialItems" showClear optionLabel="name"
                            placeholder="كل البنود" @change="onFinancialItemFilterChange" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label>حالة الدفع</label>
                        <Dropdown v-model="paymentStatus" :options="paymentStatusList" optionLabel="title"
                            placeholder="حالة الدفع" :disabled="!filterFinancialItem" @change="fetchStudents(1)" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-3 col-12">
                    <div class="d-flex">
                        <div class="form-group d-flex flex-column mx-1">
                            <label class="non_opacity">Excel</label>
                            <button class="btn btn-success px-3" @click="exportToExcel">
                                <i class="pi pi-file-excel"></i>
                            </button>
                        </div>
                        <div class="form-group d-flex flex-column mx-1">
                            <label class="non_opacity">طباعة</label>
                            <button class="btn btn-danger px-3" v-print="'#paymentsTable'">
                                <i class="pi pi-file-pdf"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ── Bulk unpaid notify ── -->
        <div class="row mb-3 mt-1" v-if="financialItems.length > 0">
            <div class="col-12">
                <div class="d-flex align-items-center gap-2 flex-wrap">
                    <Dropdown
                        v-model="bulkNotifyItem"
                        :options="financialItems"
                        optionLabel="name"
                        placeholder="اختر البند لإشعار غير المسددين..."
                        style="min-width:250px"
                    />
                    <button class="btn btn-warning" @click="sendBulkUnpaidNotify"
                        :disabled="bulkNotifying || !bulkNotifyItem">
                        <i class="pi pi-bell me-1"></i>
                        {{ bulkNotifying ? 'جاري الإرسال...' : 'إرسال إشعار غير المسددين' }}
                    </button>
                </div>
            </div>
        </div>

        <!-- ── No items warning ── -->
        <div v-if="!loadingItems && financialItems.length === 0" class="alert alert-warning">
            لا توجد بنود مالية لهذا الفصل.
            <router-link to="/financial-settings" class="alert-link ms-1">
                أضف بنوداً من الإعدادات المالية
            </router-link>
        </div>

        <!-- ── Main Table ── -->
        <div class="row">
            <div id="paymentsTable" class="a4">
                <div class="first-screen-pdf">
                    <h1>شيت المدفوعات</h1>
                    <h2>{{ gradeName }}</h2>
                    <h3>{{ gender?.id === 1 ? 'بنين' : gender?.id === 2 ? 'بنات' : '' }} ({{ paggination }})</h3>
                    <h3 v-if="filterFinancialItem">{{ filterFinancialItem.name }}</h3>
                </div>

                <table class="table table-striped table-confirm">
                    <thead>
                        <tr>
                            <th scope="col" rowspan="2">رقم</th>
                            <th scope="col" rowspan="2">الاسم</th>
                            <th scope="col" rowspan="2">رقم الحجز</th>
                            <th scope="col" rowspan="2">رقم ولي الأمر</th>
                            <th scope="col" :colspan="visibleFinancialItems.length || 1">
                                البنود المالية
                            </th>
                        </tr>
                        <tr>
                            <th v-if="visibleFinancialItems.length === 0" class="month text-muted">—</th>
                            <th v-for="item in visibleFinancialItems" :key="item.id" class="month pay-col">
                                {{ item.name }}
                                <div v-if="item.amount" class="item-amount">{{ item.amount }} ج</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(student, index) in reservations.data" :key="student.user_id"
                            :data-student-row="student.user_id"
                            :class="{ 'row-highlight': highlightedStudentId === student.user_id }">
                            <td data-label="رقم">{{ rowNumber(index) }}</td>
                            <td data-label="الاسم">{{ student.name }}</td>
                            <td data-label="رقم الحجز">{{ student.reservation_number }}</td>
                            <td data-label="رقم ولي الأمر">{{ student.parent_phone }}</td>
                            <td v-if="visibleFinancialItems.length === 0"></td>
                            <td v-for="item in visibleFinancialItems" :key="item.id"
                                class="pay-cell"
                                :class="{ 'pay-cell--paid': isPaid(student.user_id, item.id) }"
                                :title="getPaidTitle(student.user_id, item.id)"
                                @click="handleCellClick(student, item)">
                                <i v-if="isPaid(student.user_id, item.id)" class="pi pi-check pay-check"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- ── Pagination ── -->
        <div class="row">
            <div class="col-md-10 col-12">
                <pagination :data="reservations"
                    class="mx-auto d-flex align-items-center justify-content-center pagination"
                    @pagination-change-page="fetchStudents">
                    <template v-slot:prev-nav>&lt;</template>
                    <template v-slot:next-nav>&gt;</template>
                </pagination>
            </div>
            <div class="col-md-2 col-12 mt-md-0 mt-3">
                <div class="form-group d-flex md-justify-content-end justify-content-center">
                    <Dropdown v-model="per_page" :options="per_pages" showClear optionLabel="title"
                        placeholder="عدد الطلاب" @change="fetchStudents(1)" />
                </div>
            </div>
        </div>

    </div>

    <!-- ── Mobile warning ── -->
    <div class="absence-page-mobile">
        يجب فتح هذا الجدول من جهاز الكمبيوتر
    </div>

    <!-- ── Payment Details Dialog ── -->
    <Dialog v-model:visible="detailsVisible" modal header="تفاصيل الدفع"
        :style="{ width: '40vw' }" :breakpoints="{ '1199px': '65vw', '575px': '90vw' }">
        <div v-if="selectedPayment">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <th class="bg-light" style="width:40%">الطالب</th>
                        <td>{{ selectedPayment.student_name }}</td>
                    </tr>
                    <tr>
                        <th class="bg-light">البند المالي</th>
                        <td>{{ selectedPayment.item_name }}</td>
                    </tr>
                    <tr v-if="selectedPayment.amount">
                        <th class="bg-light">القيمة</th>
                        <td>{{ selectedPayment.amount }} جنيه</td>
                    </tr>
                    <tr>
                        <th class="bg-light">تاريخ الدفع</th>
                        <td>{{ formatDate(selectedPayment.paid_at) }}</td>
                    </tr>
                    <tr>
                        <th class="bg-light">وقت الدفع</th>
                        <td>{{ formatTime(selectedPayment.paid_at) }}</td>
                    </tr>
                    <tr v-if="selectedPayment.paid_by_name">
                        <th class="bg-light">سُجّل بواسطة</th>
                        <td>{{ selectedPayment.paid_by_name }}</td>
                    </tr>
                    <tr v-if="selectedPayment.notes">
                        <th class="bg-light">ملاحظات</th>
                        <td>{{ selectedPayment.notes }}</td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-danger mt-2" @click="removePayment">
                <i class="pi pi-trash me-1"></i> إلغاء تسجيل الدفع
            </button>
        </div>
    </Dialog>

    <!-- ── Notification Dialog ── -->
    <Dialog v-model:visible="notifyVisible" modal header="رسالة تأكيد الدفع"
        :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <Textarea v-model="paymentMessage" style="display:block;width:100%;" cols="30" rows="7" />
        <div class="text-end mt-1" :class="paymentMessage.length > 70 ? 'text-danger' : 'text-success'">
            {{ paymentMessage.length }} حرف
            <span class="ms-2">عدد الرسائل: {{ smsCount }}</span>
        </div>
        <button type="button" class="PrimaryButton mt-3" @click="sendNotification">إرسال</button>
    </Dialog>
</template>

<script>
import axios from 'axios';
import Dropdown from 'primevue/dropdown';
import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';
import pagination from 'laravel-vue-pagination';
import * as XLSX from 'xlsx/xlsx.mjs';
import Swal from 'sweetalert2';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import BarcodeScanner from '@/components/global/BarcodeScanner.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';
import { useNotificationStore } from '@/stores/useNotificationStore.js';

// Options for the "نظام الدراسة" listing filter — wire values match
// users.study_mode exactly ('hybrid' | 'online' | 'offline'), the same values
// AdminReservationApiService::index() already filters on (see its `study_mode`
// `when()` clause). Deliberately only these three — no "الكل"/clear option —
// so the payments list is always scoped to one study mode, defaulting to
// hybrid on every fresh page load.
const STUDY_MODE_FILTER_OPTIONS = [
    { id: 'hybrid', title: 'أونلاين + حضوري' },
    { id: 'online', title: 'أونلاين فقط' },
    { id: 'offline', title: 'حضوري فقط' },
];

export default {
    name: 'PaymentsPage',
    components: { Dropdown, Dialog, Textarea, pagination, Breadcrumb, BarcodeScanner },

    data() {
        // "الكل" is the default so the page loads every student up front
        // instead of only page 1 — fetchStudents() also sends show_all=1
        // whenever this option is selected, reusing
        // AdminReservationApiService::index()'s own "return every matching
        // row" flag instead of relying on per_page=10000 as a large-number
        // approximation.
        const per_pages = [
            { title: 'الكل', id: 10000 },
            { title: 10,     id: 10 },
            { title: 25,     id: 25 },
            { title: 50,     id: 50 },
            { title: 100,    id: 100 },
        ];
        return {
            // Students (paginated)
            reservations: { data: [] },
            currentPage: 1,
            paggination: '',
            per_page: per_pages[0],
            per_pages,

            // Filters
            word: '',
            gender: { id: null, title: 'الكل' },
            gender_list: [
                { id: null, title: 'الكل' },
                { id: 1, title: 'ولد' },
                { id: 2, title: 'بنت' },
            ],
            // Defaults to hybrid on every page open (per spec) — never persisted
            // across mounts, same as every other filter on this page.
            studyModeFilter: STUDY_MODE_FILTER_OPTIONS[0],
            studyModeFilterOptions: STUDY_MODE_FILTER_OPTIONS,
            // Filters the student list by a specific financial item's payment
            // status — separate from selectedQrItem below (which item the QR
            // scanner marks paid), even though both draw from financialItems.
            filterFinancialItem: null,
            paymentStatus: { id: 'all', title: 'الكل' },
            paymentStatusList: [
                { id: 'all', title: 'الكل' },
                { id: 'paid', title: 'مدفوع' },
                { id: 'unpaid', title: 'غير مدفوع' },
            ],

            // Financial data
            financialItems: [],
            loadingItems: true,
            selectedQrItem: null,
            // paymentsMap[student_id][item_id] = { id, paid_at, paid_by_name, notes }
            paymentsMap: {},

            // QR scan lookup
            scanLookupLoading: false,
            isProcessingScan: false,
            recentPaymentScans: {},
            // Page-level duplicate-payment guard (separate from BarcodeScanner's
            // own DEBOUNCE_MS) — keyed by resolved student/qrToken/raw so it
            // still catches duplicates BarcodeScanner's own dedupe wouldn't (e.g.
            // the same student scanned via two different raw QR encodings).
            // Kept in lockstep with BarcodeScanner's DEBOUNCE_MS (1200ms) so the
            // two independent guards never combine into a longer effective
            // cooldown than 1.2s.
            SCAN_COOLDOWN_MS: 1200,
            highlightedStudentId: null,

            // Payment details dialog
            detailsVisible: false,
            selectedPayment: null,

            // Notification dialog
            notifyVisible: false,
            paymentMessage: '',
            currentParentPhone: null,

            // Bulk unpaid notify
            bulkNotifyItem: null,
            bulkNotifying: false,

            // Templates cache
            templates: {},
        };
    },

    computed: {
        gradeStore() { return useGradeStore(); },
        notificationStore() { return useNotificationStore(); },

        currentGrade() {
            const slug = this.$route.params.gradeSlug ?? this.$route.params.slug;
            return this.gradeStore.activeGrades.find(g => g.slug === slug)
                ?? this.gradeStore.allGrades.find(g => g.slug === slug)
                ?? this.gradeStore.currentGrade;
        },

        gradeName() { return this.currentGrade?.name ?? ''; },

        perPageValue() { return this.per_page ? this.per_page.id : 10; },

        smsCount() { return Math.ceil(this.paymentMessage.length / 70) || 1; },

        // When a financial item is selected as a filter, the table (and its
        // print output, which targets this same DOM) must show ONLY that
        // item's column — not every item — or the filter is purely cosmetic.
        visibleFinancialItems() {
            return this.filterFinancialItem ? [this.filterFinancialItem] : this.financialItems;
        },

        breadcrumbs() {
            return [
                { name: 'الرئيسية', path: '/' },
                { name: this.gradeName || 'الفصل', path: '/' },
                { name: 'المدفوعات', path: this.$route.fullPath },
            ];
        },
    },

    methods: {
        // ── Data Loading ────────────────────────────────────────────────

        async fetchStudents(page = 1) {
            if (!this.currentGrade) return;
            this.currentPage = page;

            const formData = new FormData();
            formData.append('status', 1);
            formData.append('order_by_name', 1);
            formData.append('academic_year_id', this.currentGrade.id);
            if (this.word) formData.append('word', this.word);
            // gender.id is null for "الكل" — must NOT be sent, or the backend
            // would filter on an empty value instead of returning both genders.
            if (this.gender?.id) formData.append('gender', this.gender.id);
            if (this.studyModeFilter?.id) formData.append('study_mode', this.studyModeFilter.id);
            // Payment status is only meaningful together with a selected item —
            // the dropdown is disabled without one, but guard here too.
            if (this.filterFinancialItem) {
                formData.append('financial_item_id', this.filterFinancialItem.id);
                if (this.paymentStatus?.id && this.paymentStatus.id !== 'all') {
                    formData.append('payment_status', this.paymentStatus.id);
                }
            }
            // "الكل" (per_pages[0]) — reuse the backend's own "return every
            // matching row" flag (AdminReservationApiService::index()) rather
            // than approximate it with a very large per_page.
            if (this.per_page?.id === 10000) formData.append('show_all', 1);

            // per_page sent as an explicit query param on THIS request only —
            // not a global axios default header, which used to leak into any
            // other request in flight (including this page's own other calls)
            // and was part of why pagination misbehaved.
            axios.post(`/all_reservations?page=${page}&per_page=${this.perPageValue}`, formData)
                .then(res => {
                    this.reservations = res.data.data;
                    this.paggination = res.data.data.meta?.total ?? 0;
                })
                .catch(() => { this.reservations = { data: [] }; });
        },

        // Financial item filter changed: reset the (now meaningless without a
        // selected item) payment-status filter back to "الكل" if the item was
        // cleared, then refetch from page 1 with the new filter combination.
        onFinancialItemFilterChange() {
            if (!this.filterFinancialItem) {
                this.paymentStatus = this.paymentStatusList[0];
            }
            this.fetchStudents(1);
        },

        async loadFinancialItems() {
            this.loadingItems = true;
            if (!this.currentGrade) return;
            const res = await axios.get('/financial-items', {
                params: { academic_year_id: this.currentGrade.id },
            });
            this.financialItems = res.data.data ?? [];
            this.loadingItems = false;
        },

        async loadPayments() {
            if (!this.currentGrade) return;
            const res = await axios.get(`/payments/by-academic-year/${this.currentGrade.id}`);
            const data = res.data.data ?? [];
            const map = {};
            for (const row of data) {
                map[row.student_id] = {};
                for (const [itemId, details] of Object.entries(row.payment_details ?? {})) {
                    map[row.student_id][itemId] = details;
                }
            }
            this.paymentsMap = map;
        },

        // ── Payment State ────────────────────────────────────────────────

        isPaid(studentId, itemId) {
            return !!(this.paymentsMap[studentId]?.[String(itemId)]);
        },

        getPaidTitle(studentId, itemId) {
            const d = this.paymentsMap[studentId]?.[String(itemId)];
            if (!d) return '';
            const who = d.paid_by_name ? `\nبواسطة: ${d.paid_by_name}` : '';
            return `تم الدفع: ${this.formatDate(d.paid_at)}${who}`;
        },

        rowNumber(index) {
            return (this.currentPage - 1) * this.perPageValue + index + 1;
        },

        // ── Interactions ────────────────────────────────────────────────

        async handleCellClick(student, item) {
            if (this.isPaid(student.user_id, item.id)) {
                // Show details
                const d = this.paymentsMap[student.user_id][String(item.id)];
                this.selectedPayment = {
                    student_id: student.user_id,
                    student_name: student.name,
                    item_id: item.id,
                    item_name: item.name,
                    amount: item.amount,
                    paid_at: d.paid_at,
                    paid_by_name: d.paid_by_name,
                    notes: d.notes,
                };
                this.detailsVisible = true;
            } else {
                // Mark as paid
                await this.markPaid(student, item);
            }
        },

        async markPaid(student, item) {
            const res = await axios.post('/payments/mark-paid', {
                student_id: student.user_id,
                financial_item_id: item.id,
            }).catch(err => { console.error(err); return null; });

            if (!res?.data?.status) return;

            // Refresh payment map
            await this.loadPayments();

            this.notificationStore.push({
                icon:  'success',
                title: 'تم تسجيل الدفع',
                text:  `${student.name} — ${item.name}`,
            });

            // The backend already sent the "payment_confirmation" WhatsApp message
            // automatically (see StudentPaymentController::sendPaymentConfirmation).
            // A WhatsApp delivery failure is logged server-side but never shown to
            // the operator here — the payment itself is already committed either way.
        },

        async removePayment() {
            const result = await Swal.fire({
                title: 'إلغاء تسجيل الدفع',
                html: `سيتم إلغاء دفع <strong>${this.selectedPayment.item_name}</strong><br>للطالب: ${this.selectedPayment.student_name}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'نعم، إلغاء الدفع',
                cancelButtonText: 'لا',
                confirmButtonColor: '#dc3545',
            });
            if (!result.isConfirmed) return;

            await axios.post('/payments/mark-paid', {
                student_id: this.selectedPayment.student_id,
                financial_item_id: this.selectedPayment.item_id,
            });
            this.detailsVisible = false;
            await this.loadPayments();
        },

        // ── Templates ────────────────────────────────────────────────

        async loadTemplates() {
            try {
                const res = await axios.get('/whatsapp-templates');
                const list = res.data.data ?? [];
                this.templates = Object.fromEntries(list.map(t => [t.code, t]));
            } catch { /* non-fatal */ }
        },

        // ── Notification ────────────────────────────────────────────────

        buildMessage(studentName, item, paidAt) {
            const tpl = this.templates['payment_confirmation'];
            if (tpl?.is_active) {
                return tpl.message
                    .replace(/\{\{student_name\}\}/g, studentName)
                    .replace(/\{\{fee_name\}\}/g, item.name)
                    .replace(/\{\{fee_amount\}\}/g, item.amount ?? '')
                    .replace(/\{\{date\}\}/g, this.formatDate(paidAt))
                    .replace(/\{\{time\}\}/g, this.formatTime(paidAt))
                    .replace(/\{\{teacher_name\}\}/g, 'أ.طارق عبدالغني عبدالباري');
            }
            const amountLine = item.amount ? `\nقيمة الرسوم:\n${item.amount} جنيه\n` : '';
            return `تم تسجيل سداد رسوم الطالب:\n${studentName}\n\nالبند المالي:\n${item.name}\n${amountLine}\nتاريخ السداد:\n${this.formatDate(paidAt)}\n\nالوقت:\n${this.formatTime(paidAt)}\n\nشكراً لكم.`;
        },

        async sendBulkUnpaidNotify() {
            if (!this.currentGrade || !this.bulkNotifyItem) return;

            const result = await Swal.fire({
                title:             'إرسال إشعار غير المسددين',
                html:              `سيتم إرسال إشعار لجميع الطلاب الذين لم يسددوا <strong>${this.bulkNotifyItem.name}</strong>`,
                icon:              'question',
                showCancelButton:  true,
                confirmButtonText: 'نعم، إرسال',
                cancelButtonText:  'إلغاء',
            });

            if (!result.isConfirmed) return;

            this.bulkNotifying = true;
            try {
                const res = await axios.post('/payments/bulk-notify-unpaid', {
                    academic_year_id:  this.currentGrade.id,
                    financial_item_id: this.bulkNotifyItem.id,
                });
                const { total_recipients, queued_chunks, failed_chunks } = res.data;
                Swal.fire({
                    icon:  queued_chunks > 0 ? 'success' : 'info',
                    title: 'اكتمل الإرسال',
                    html:  `عدد المستلمين: <strong>${total_recipients}</strong><br>دفعات تم إرسالها: <strong>${queued_chunks}</strong><br>دفعات فشلت: <strong>${failed_chunks}</strong>`,
                    timer: 6000,
                    showConfirmButton: true,
                });
            } catch {
                Swal.fire({ icon: 'error', title: 'خطأ', text: 'حدث خطأ أثناء الإرسال', timer: 3000, showConfirmButton: false });
            } finally {
                this.bulkNotifying = false;
            }
        },

        async sendNotification() {
            const phone = '2' + this.currentParentPhone;

            // 1. Check WhatsApp
            let hasWhatsApp = false;
            try {
                const r = await axios.post('/whatsapp/check', { phone });
                hasWhatsApp = r.data.has_whatsapp === true;
            } catch { hasWhatsApp = false; }

            // 2. Send WhatsApp
            if (hasWhatsApp) {
                try {
                    const r = await axios.post('/whatsapp/send', { phone, message: this.paymentMessage });
                    if (r.data.success) {
                        Swal.fire({ icon: 'success', title: 'تم الإرسال', text: 'تم إرسال الرسالة عبر واتساب بنجاح', timer: 1500, showConfirmButton: false });
                        this.notifyVisible = false;
                        return;
                    }
                } catch { /* fall through */ }
            }

            // 3. SMS fallback — same implementation as attendance
            const formData = new FormData();
            formData.append('SenderName', 'SMS invite');
            formData.append('RequestID', Date.now());
            formData.append('PhoneNumber', phone);
            formData.append('Message', this.paymentMessage);

            await axios.post(
                'https://hubapi.advansystelecom.com/api/bulkSMS/ForwardSMS',
                formData,
                { headers: { 'Authorization': '667d0a1e-f2b3-4bd5-8569-360b6e7b80b0', 'Content-Type': 'application/json' } }
            ).then(res => {
                if (res.data === '1') {
                    Swal.fire({ icon: 'success', title: 'تم الإرسال', text: 'تم إرسال الرسالة بنجاح', timer: 1500, showConfirmButton: false });
                    this.notifyVisible = false;
                }
            }).catch(err => {
                const code = err.response?.data?.Message;
                const msgs = { '-1': 'رمز التوثيق غير صحيح', '-2': 'رقم الجوال فارغ', '-3': 'نص الرسالة فارغ', '-4': 'اسم المرسل غير صحيح', '-5': 'لا يوجد رصيد كافٍ' };
                Swal.fire({ icon: 'error', title: 'خطأ', text: msgs[code] ?? 'حدث خطأ غير متوقع', timer: 3000, showConfirmButton: false });
            });
        },

        // ── Formatting ────────────────────────────────────────────────

        formatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
        },

        formatTime(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            let h = d.getHours();
            const m = String(d.getMinutes()).padStart(2, '0');
            const period = h >= 12 ? 'مساءً' : 'صباحاً';
            h = h % 12 || 12;
            return `${h}:${m} ${period}`;
        },

        // ── QR Payment ────────────────────────────────────────────────

        handlePaymentScanError({ message } = {}) {
            this.notificationStore.push({
                icon: 'error',
                title: message || 'QR غير صالح',
                timeout: 5000,
            });
        },

        async handlePaymentQR({ raw, qrToken, studentId }) {
            console.log('[Payments] Callback fired', { raw, qrToken, studentId });

            const item = this.selectedQrItem;
            if (!item || !this.currentGrade || this.isProcessingScan) return;

            const scanKey = qrToken
                ? `qr:${qrToken}`
                : studentId
                    ? `student:${studentId}`
                    : `raw:${raw}`;
            const now = Date.now();
            if (now - (this.recentPaymentScans[scanKey] ?? 0) < this.SCAN_COOLDOWN_MS) {
                console.log('[Payments] Duplicate payment scan ignored:', scanKey);
                return;
            }

            for (const [key, scannedAt] of Object.entries(this.recentPaymentScans)) {
                if (now - scannedAt >= this.SCAN_COOLDOWN_MS) delete this.recentPaymentScans[key];
            }
            this.recentPaymentScans[scanKey] = now;
            this.isProcessingScan = true;
            this.scanLookupLoading = true;

            try {
                // Single-request flow: BarcodeScanner (payment mode) no longer
                // resolves the token itself via GET /qr/resolve/{token} — it
                // hands the raw token straight through, and POST
                // /payments/qr-mark-paid resolves it AND marks the payment in
                // the SAME request. One physical scan = one API call.
                if (qrToken) {
                    await this.markPaidFromScan(null, item, qrToken);
                    return;
                }

                if (studentId == null) {
                    this.notificationStore.push({
                        icon: 'error',
                        title: 'QR غير صالح',
                        timeout: 5000,
                    });
                    return;
                }

                // Legacy STU-/numeric scans: the id is already known, no resolve
                // step needed — only enrich the display name from the visible page.
                const visibleStudent = this.reservations.data?.find(
                    (row) => String(row.user_id) === String(studentId)
                );
                const student = {
                    ...visibleStudent,
                    user_id: Number(studentId),
                    name: visibleStudent?.name ?? `#${studentId}`,
                };

                // paymentsMap is loaded once for the academic year and kept in
                // sync after each QR payment. Skip a write that is already known
                // to be paid; qr-mark-paid remains authoritative for stale state.
                if (this.isPaid(student.user_id, item.id)) {
                    this.notificationStore.push({
                        icon:  'warning',
                        title: 'تم تسجيل الدفع مسبقاً',
                        text:  `${student.name} — ${item.name}`,
                        timeout: 5000,
                    });
                    await this.revealStudentRow(student.user_id);
                    return;
                }

                await this.markPaidFromScan(student, item);
            } catch (err) {
                console.log('[Payments] QR payment failed:', err);
                this.notificationStore.push({
                    icon: 'error',
                    title: err.response?.data?.message ?? 'تعذّر تسجيل الدفع',
                    timeout: 5000,
                });
            } finally {
                this.recentPaymentScans[scanKey] = Date.now();
                this.scanLookupLoading = false;
                this.isProcessingScan = false;
            }
        },

        // Marks payment for EITHER an already-resolved student (POSTs
        // {student_id} — the legacy STU-/numeric-id path) OR a raw QR token
        // (POSTs {qr_token} — the single-request scan flow: the backend
        // resolves the token AND marks the payment in this SAME call). The
        // backend returns this student's complete payment snapshot (including
        // its resolved name/id), allowing a single targeted state replacement
        // instead of a full payments reload — and gives the notification text
        // its student name even when no local `student` was resolved.
        async markPaidFromScan(student, item, qrToken = null) {
            const payload = {
                financial_item_id: item.id,
            };
            if (qrToken) payload.qr_token = qrToken;
            else payload.student_id = student.user_id;

            const res = await axios.post('/payments/qr-mark-paid', payload);

            const resolvedStudentId = res.data.data?.student_id ?? student?.user_id ?? null;
            const studentName = res.data.student_name || student?.name || '';
            console.log('[Payments] Page action executed: payment marked for', resolvedStudentId);

            this.applyStudentPaymentState(res.data.data);

            if (res.data.status === 'already_paid') {
                this.notificationStore.push({
                    icon:  'warning',
                    title: 'تم تسجيل الدفع مسبقاً',
                    text:  `${studentName} — ${res.data.item_name}`,
                    timeout: 5000,
                });
            } else {
                this.notificationStore.push({
                    icon:  'success',
                    title: 'تم تسجيل الدفع بنجاح',
                    text:  `${studentName} — ${res.data.item_name}`,
                    timeout: 5000,
                });

                // The backend already sent the "payment_confirmation" WhatsApp message
                // automatically. A WhatsApp delivery failure is logged server-side but
                // never shown here — the payment itself is already committed either way.
            }

            if (resolvedStudentId != null) await this.revealStudentRow(resolvedStudentId);
        },

        applyStudentPaymentState(paymentState) {
            if (!paymentState?.student_id) return;

            const studentId = Number(paymentState.student_id);
            const paymentDetails = { ...(paymentState.payment_details ?? {}) };

            this.paymentsMap = {
                ...this.paymentsMap,
                [studentId]: paymentDetails,
            };

            // Keep any currently-rendered reservation row consistent too. This
            // mutates only the affected student; no reservations request is made.
            const row = this.reservations.data?.find(
                (student) => String(student.user_id) === String(studentId)
            );
            if (row) {
                row.paid_items = [...(paymentState.paid_items ?? [])];
                row.payment_details = paymentDetails;
            }
        },

        // Reveal a row only when it is already rendered. An off-page scan must not
        // trigger a full reservations reload merely for scrolling/highlighting.
        // NEVER calls scrollIntoView()/scrollTo() here — a QR scan must never move
        // the viewport; the row is only flash-highlighted in place.
        async revealStudentRow(studentId) {
            const alreadyVisible = this.reservations.data?.some(
                (student) => String(student.user_id) === String(studentId)
            );
            if (!alreadyVisible) return;

            await this.$nextTick();

            this.highlightedStudentId = studentId;
            setTimeout(() => {
                if (this.highlightedStudentId === studentId) this.highlightedStudentId = null;
            }, 2000);
        },

        // ── Export ────────────────────────────────────────────────

        exportToExcel() {
            const table = document.getElementById('paymentsTable').cloneNode(true);
            const ws = XLSX.utils.table_to_sheet(table);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'المدفوعات');
            XLSX.writeFile(wb, `مدفوعات-${this.gradeName}.xlsx`);
        },
    },

    async mounted() {
        if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
        if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();

        await Promise.all([this.loadFinancialItems(), this.loadPayments(), this.loadTemplates()]);
        this.fetchStudents(1);

        // Restore QR selected item from localStorage
        const saved = localStorage.getItem('selected_payment_item');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                const match = this.financialItems.find(i => i.id === parsed.id);
                if (match) this.selectedQrItem = match;
            } catch {}
        }
    },

    watch: {
        '$route.params.gradeSlug': {
            async handler() {
                await Promise.all([this.loadFinancialItems(), this.loadPayments()]);
                this.fetchStudents(1);
                // Re-resolve selected QR item after reloading financial items
                const saved = localStorage.getItem('selected_payment_item');
                if (saved) {
                    try {
                        const parsed = JSON.parse(saved);
                        const match = this.financialItems.find(i => i.id === parsed.id);
                        this.selectedQrItem = match ?? null;
                    } catch {}
                }
            },
        },

        selectedQrItem(val) {
            if (val) {
                localStorage.setItem('selected_payment_item', JSON.stringify({ id: val.id, name: val.name }));
            } else {
                localStorage.removeItem('selected_payment_item');
            }
        },
    },
};
</script>

<style scoped>
/* ── Payment cells ── */
.pay-cell {
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    min-width: 55px;
    transition: background-color 0.15s;
}
.pay-cell:hover {
    background-color: #e8f5e9 !important;
}
.pay-cell--paid {
    background-color: #d4edda;
}
.pay-cell--paid:hover {
    background-color: #c3e6cb !important;
}
.pay-check {
    color: #28a745;
    font-size: 1rem;
}

/* ── QR scan result ── */
.row-highlight {
    animation: row-highlight-flash 2s ease-out;
}
@keyframes row-highlight-flash {
    0%, 40%   { background-color: #fff3cd; }
    100%      { background-color: transparent; }
}

/* ── Column headers ── */
th.pay-col {
    min-width: 60px;
    font-size: 0.82rem;
    text-align: center;
    vertical-align: bottom;
    white-space: nowrap;
}
.item-amount {
    font-size: 0.7rem;
    color: #6c757d;
    font-weight: normal;
}

/* Sticky header: this table's two header rows (rowspan'd id/name/etc. columns
   + the per-financial-item month row) stick together as one unit — sticky on
   <thead> itself, not per-row/th, so no fragile row-height math is needed to
   stack a second row beneath the first. Pinned below the app's own sticky
   navbar (--navbar-height) so it never overlaps it. The page's existing
   horizontal scroll is untouched — sticky here only affects the vertical axis. */
#paymentsTable table.table-confirm thead {
    position: sticky;
    top: var(--navbar-height, 64px);
    z-index: 2;
}
#paymentsTable table.table-confirm thead th {
    background-color: var(--surface-card, #fff);
}
#paymentsTable table.table-confirm thead tr:last-child th {
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
}

/* ── Print styles ── */
@media print {
    /* Root cause of the "N blank pages" bug: grades/students.vue ships a
       page-wide (unscoped) print rule — `body * { visibility: hidden !important; }`,
       revealed only for its OWN #printReport target — that ships on every
       route because vue3-print-nb (see the v-print directive above) builds
       its print document by copying every rule out of document.styleSheets,
       not just this component's own CSS. Without an exception for THIS
       page's print target, #paymentsTable inherited visibility:hidden while
       still reserving its full layout height, which is exactly "N pages,
       all blank" (as opposed to display:none, which would collapse to
       nothing). Same fix already applied for the same reason in
       grades/groups/show.vue's #groupStudentsExportTable — mirrored here,
       not modifying grades/students.vue's rule or any other page. */
    #paymentsTable,
    #paymentsTable * {
        visibility: visible !important;
    }

    /* style.scss's shared .a4/.first-screen-pdf pair is a cover-page pattern
       built for dedicated print-report routes (e.g. students_barcodes_print.vue)
       where a full A4 title page in front of the content is the point. Reused
       as-is here it forced #paymentsTable (via .a4) to a fixed one-page
       height and rendered a 196mm x 284mm flex box (via .first-screen-pdf,
       display:flex!important, h1 at 5rem) just to center three lines of
       text — i.e. one whole extra, mostly-blank page before any real data,
       on every print. Overridden here (scoped to #paymentsTable only, not
       editing style.scss so every other page keeping the real cover-page
       behavior is untouched) into a compact header that flows with the
       table instead of reserving its own page. */
    /* style.scss's .a4 class (see block above) also pins a fixed
       width: 196mm — sized for a near-zero-margin print doc, which this
       page never declared. Chrome's own default print margins (no @page
       rule exists anywhere in the app) leave less than 196mm of printable
       width on an A4 page, so the container was always wider than the
       page. In this RTL document a block that's wider than its containing
       block anchors to its start edge (the RIGHT, in RTL) and overflows
       past the END edge (the LEFT) — exactly the reported bug: right
       border intact, left border clipped, whole table shifted left off
       the page. Replaced with a width that's defined relative to
       whatever printable area Chrome actually computes, instead of an
       absolute mm value that assumes one specific margin setting. */
    #paymentsTable {
        height: auto !important;
        min-height: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        /* vue3-print-nb prints #paymentsTable as the print document's own
           root node, detached from the .container-fluid/.row ancestors
           that carry the app's RTL context on screen — pin it explicitly
           here rather than relying on that removed ancestry. */
        direction: rtl;
    }
    #paymentsTable table {
        width: 100% !important;
        max-width: 100% !important;
    }
    #paymentsTable .first-screen-pdf {
        display: block !important;
        width: auto !important;
        height: auto !important;
        border: none !important;
        margin: 0 0 4mm !important;
        page-break-after: avoid;
        break-after: avoid;
    }
    #paymentsTable .first-screen-pdf h1 {
        font-size: 1.4rem !important;
        margin: 0 0 2mm !important;
    }
    #paymentsTable .first-screen-pdf h2,
    #paymentsTable .first-screen-pdf h3 {
        font-size: 1rem !important;
        margin: 0 0 1mm !important;
    }

    .table > :not(caption) > * > * {
        border-width: 2px !important;
        border-color: #000 !important;
    }
    table * {
        font-size: 0.8rem !important;
        font-weight: 900;
    }
    th.pay-col {
        min-width: 30px !important;
        width: 30px !important;
        white-space: normal;
    }
    .pay-cell--paid {
        background-color: #d4edda !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    /* Table header must repeat on every printed page; each data row must
       stay on one page instead of splitting across a page break. Applied
       per-row (not to the whole table) so this can't itself force
       everything onto a single page. */
    #paymentsTable table thead {
        display: table-header-group;
        position: static;
    }
    #paymentsTable table tbody {
        display: table-row-group;
    }
    #paymentsTable table tbody tr {
        break-inside: avoid;
        page-break-inside: avoid;
    }

    /* style.scss also ships a leftover, unscoped `table thead/tbody
       th/td:nth-child(6),(8) { display:none }` print rule (a vestige of an
       older, wider table — the surrounding class-based version of the same
       idea is already commented out there). Its bare `table` selector
       matches this table too: with 2+ financial items the 2nd/4th item
       column lands on position 6/8 and silently disappears from print.
       Neutralized here for #paymentsTable only; style.scss itself is left
       alone so any other page still relying on it is unaffected. */
    #paymentsTable table thead tr th,
    #paymentsTable table tbody tr td {
        display: table-cell !important;
    }
}
</style>
